import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getBrokers(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getbrokers/jv",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getJvBrokerEntry(payload) {
    const result = await axios.post(apiUrl + "/jv/entry",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}


export const JvBrokerServices = {
    getBrokers,
    getJvBrokerEntry,
}